module.exports = __webpack_public_path__ + "static/media/johnMarion16.d895bc7a.png";